import React from "react";

const SignInIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.68487 20.9372C9.96685 22.1609 11.6002 22.9943 13.3783 23.3319C15.1565 23.6695 16.9996 23.4962 18.6746 22.8339C20.3496 22.1717 21.7812 21.0502 22.7885 19.6112C23.7957 18.1723 24.3333 16.4806 24.3333 14.75C24.3333 13.0194 23.7957 11.3277 22.7885 9.88876C21.7812 8.44983 20.3496 7.32832 18.6746 6.66605C16.9996 6.00379 15.1565 5.83051 13.3784 6.16813C11.6002 6.50575 9.96685 7.33911 8.68487 8.56281"
                stroke={"#e1e1e1"}
                strokeWidth="2"
            />
            <path
                d="M17.9167 14.75L18.6831 14.1077L19.2214 14.75L18.6831 15.3923L17.9167 14.75ZM6.91669 15.75C6.3644 15.75 5.91669 15.3023 5.91669 14.75C5.91669 14.1977 6.3644 13.75 6.91669 13.75V15.75ZM15.0164 9.73266L18.6831 14.1077L17.1503 15.3923L13.4836 11.0173L15.0164 9.73266ZM18.6831 15.3923L15.0164 19.7673L13.4836 18.4827L17.1503 14.1077L18.6831 15.3923ZM17.9167 15.75H6.91669V13.75H17.9167V15.75Z"
                fill={"#e1e1e1"}
            />
        </svg>
    );
};

export default SignInIcon;
